import { Injectable } from '@angular/core';
import { localStorageService } from '../localStorage/localStorage.service';
export const TOKEN_NAME: string = 'token';

@Injectable()
export class AuthService {

  constructor(private localStorage:localStorageService){
    
  }

  setToken(token: string): void {
    this.localStorage.setItem({key:TOKEN_NAME, value:token});
  }

  isAuthenticated(token?: string): boolean {
    return !!this.localStorage.getItem(TOKEN_NAME);
  }
}